// extracted by mini-css-extract-plugin
export default {"taskStatusColumn":"taskStatusColumn--JK_wm","taskStatusIcon":"taskStatusIcon--UH9c7","historyModal":"historyModal--O4br0","markerAnimationScale":"markerAnimationScale--B3STS"};